const agentLanguage: Record<string, Record<string, string>> = {
  'en-US': {
    agent_workspace_meetings: 'Meetings',
    agent_workspace_agent: 'Agent',
    agent_workspace_label: 'Switch workspace',
    agent_mode_label: 'Agent mode',
    agent_mode_chat: 'Chat',
    agent_mode_work: 'Work',
    agent_meeting_context: 'Use my meeting content',
    agent_new_chat: 'New chat',
    agent_new_task: 'New task',
    agent_my_space: 'My space',
    agent_recents: 'Recents',
    agent_conversation_options: 'Conversation options',
    agent_delete_error: 'Failed to delete this conversation. Please try again.',
    agent_recents_empty: 'Your recent chats and tasks will appear here.',
    agent_coming_soon: 'Coming soon',
    agent_work_heading: 'What should we make from your meetings?',
    agent_chat_heading: 'How can I help you today?',
    agent_chat_description: 'A little help with your questions, ideas, and everyday work.',
    agent_work_input_label: 'Describe your task',
    agent_chat_input_label: 'Write a message',
    agent_work_placeholder: 'Describe what you need. I’ll take it from here.',
    agent_chat_placeholder: 'Ask a question or share an idea…',
    agent_composer_placeholder: 'Ask the agent to do anything with your meetings',
    agent_choose_meetings: 'Choose meetings',
    agent_meeting_period: 'Last 7 days by default',
    agent_attach_files: 'Attach files',
    agent_ask_before_sending: 'Ask before sending',
    agent_output_auto: 'Output: Auto',
    agent_voice_input: 'Voice input',
    agent_send: 'Send',
    agent_draft_hint: 'Prepare a draft now. Sending and connected tools will be available soon.',
    agent_templates_label: 'Start with a task',
    agent_template_deck: 'Make a deck from action items',
    agent_template_deck_prompt: 'Make a presentation deck from the action items in my meetings.',
    agent_template_minutes: 'Write minutes in your template',
    agent_template_minutes_prompt: 'Write meeting minutes using my template, including decisions, action items, and owners.',
    agent_template_email: 'Draft follow-up emails',
    agent_template_email_prompt: 'Draft follow-up emails for my meetings with a recap of key decisions and next steps.',
    agent_template_summary: 'Summarize this week’s meetings',
    agent_template_summary_prompt: 'Summarize my meetings from this week, highlighting key decisions, outstanding questions, and action items.',
    agent_disclaimer: 'HKMeeting can make mistakes. Check important information.',
    agent_my_space_description: 'Your saved work and reusable templates will live here.',
  },
  'zh-CN': {
    agent_workspace_meetings: '会议',
    agent_workspace_agent: '智能体',
    agent_workspace_label: '切换工作区',
    agent_mode_label: '智能体模式',
    agent_mode_chat: '对话',
    agent_mode_work: '工作',
    agent_meeting_context: '使用我的会议内容',
    agent_new_chat: '新对话',
    agent_new_task: '新任务',
    agent_my_space: '我的空间',
    agent_recents: '最近记录',
    agent_conversation_options: '对话选项',
    agent_delete_error: '删除此对话失败，请重试。',
    agent_recents_empty: '最近的对话和任务将在此显示。',
    agent_coming_soon: '即将推出',
    agent_work_heading: '您想将会议内容转化成什么？',
    agent_chat_heading: '今天有什么可以帮您？',
    agent_chat_description: '协助您解答问题、整理想法和处理日常工作。',
    agent_work_input_label: '描述您的任务',
    agent_chat_input_label: '输入消息',
    agent_work_placeholder: '描述您的需求，接下来交给我。',
    agent_chat_placeholder: '提出问题或分享想法…',
    agent_composer_placeholder: '让智能体根据您的会议内容完成任何任务',
    agent_choose_meetings: '选择会议',
    agent_meeting_period: '默认最近 7 天',
    agent_attach_files: '添加附件',
    agent_ask_before_sending: '发送前询问',
    agent_output_auto: '输出：自动',
    agent_voice_input: '语音输入',
    agent_send: '发送',
    agent_draft_hint: '您可以先准备草稿。发送和关联工具即将推出。',
    agent_templates_label: '选择任务模板',
    agent_template_deck: '将行动项制作成演示文稿',
    agent_template_deck_prompt: '请根据我的会议中的行动项制作演示文稿。',
    agent_template_minutes: '使用您的模板撰写会议纪要',
    agent_template_minutes_prompt: '请使用我的模板撰写会议纪要，包括决策、行动项和负责人。',
    agent_template_email: '起草会后跟进邮件',
    agent_template_email_prompt: '请为我的会议起草跟进邮件，概述关键决策和后续步骤。',
    agent_template_summary: '总结本周的会议',
    agent_template_summary_prompt: '请总结我本周的会议，重点列出关键决策、待解决问题和行动项。',
    agent_disclaimer: '港会通可能出错，请核查重要信息。',
    agent_my_space_description: '您保存的工作成果和可重复使用的模板将在此显示。',
  },
  'zh-HK': {
    agent_workspace_meetings: '會議',
    agent_workspace_agent: '智能體',
    agent_workspace_label: '切換工作區',
    agent_mode_label: '智能體模式',
    agent_mode_chat: '對話',
    agent_mode_work: '工作',
    agent_meeting_context: '使用我的會議內容',
    agent_new_chat: '新對話',
    agent_new_task: '新任務',
    agent_my_space: '我的空間',
    agent_recents: '最近記錄',
    agent_conversation_options: '對話選項',
    agent_delete_error: '刪除此對話失敗，請重試。',
    agent_recents_empty: '最近的對話和任務將在此顯示。',
    agent_coming_soon: '即將推出',
    agent_work_heading: '您想將會議內容轉化成甚麼？',
    agent_chat_heading: '今天有甚麼可以幫您？',
    agent_chat_description: '協助您解答問題、整理想法和處理日常工作。',
    agent_work_input_label: '描述您的任務',
    agent_chat_input_label: '輸入訊息',
    agent_work_placeholder: '描述您的需求，接下來交給我。',
    agent_chat_placeholder: '提出問題或分享想法…',
    agent_composer_placeholder: '讓智能體根據您的會議內容完成任何任務',
    agent_choose_meetings: '選擇會議',
    agent_meeting_period: '預設最近 7 天',
    agent_attach_files: '新增附件',
    agent_ask_before_sending: '傳送前詢問',
    agent_output_auto: '輸出：自動',
    agent_voice_input: '語音輸入',
    agent_send: '傳送',
    agent_draft_hint: '您可以先準備草稿。傳送和關聯工具即將推出。',
    agent_templates_label: '選擇任務範本',
    agent_template_deck: '將行動項目製作成簡報',
    agent_template_deck_prompt: '請根據我的會議中的行動項目製作簡報。',
    agent_template_minutes: '使用您的範本撰寫會議紀錄',
    agent_template_minutes_prompt: '請使用我的範本撰寫會議紀錄，包括決策、行動項目和負責人。',
    agent_template_email: '草擬會後跟進電郵',
    agent_template_email_prompt: '請為我的會議草擬跟進電郵，概述關鍵決策和後續步驟。',
    agent_template_summary: '總結本週的會議',
    agent_template_summary_prompt: '請總結我本週的會議，重點列出關鍵決策、待解決問題和行動項目。',
    agent_disclaimer: '港會通可能出錯，請核查重要資訊。',
    agent_my_space_description: '您儲存的工作成果和可重複使用的範本將在此顯示。',
  },
};

export default agentLanguage;
